import React from 'react'
import Footer from "../footer";

const PortalFooter = () => (<Footer showTopFooter={false} hasToDisplayCarrierDisclaimer/>);

export default PortalFooter;

